import PackageConfirmationTravellerSection from "../../components/common/PackageConfirmationTravellerSection.jsx";

function PackageConfirmationTravelerSection({ booking }) {
  if (!booking) return <></>;

  return <PackageConfirmationTravellerSection booking={booking?.requestBody} />;
}

export default PackageConfirmationTravelerSection;
